import ParseUtil from "@/lib/parse"
import { WalletMockService } from "@/services/backend"
import { LIDService } from "@/services/loginid"
import { Oauth2Service } from "@/services/oauth2"
import { Image, Text, Stack, Flex, Title, Space, Input, Button, Stepper, PinInput, Checkbox, Divider, Group, StepperProps } from "@mantine/core"
import { IconArrowRight, IconPlayerSkipForwardFilled, IconShieldLock } from "@tabler/icons-react"
import { FormEvent, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

export enum SignupViewEnum {
  EMAIL = "email",
  OTP = "otp",
  CARD = "card",
  CVV = "cvv",
  PASSKEY = "passkey",
}

const cards = [
  {
    name: "My Bank Reward Plus",
    cardUrl: "/assets/my-bank.png",
    cardMask: "**** 1234"
  }
]

const brand = process.env.REACT_APP_BRAND || "Paze";
export function LoginPage(){
    const [query] = useSearchParams()
    const [challenge, setChallenge] = useState("")

  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [view, setView] = useState<SignupViewEnum>(SignupViewEnum.EMAIL);
  const [cardIndex, setCardIndex] = useState<number>(0);
    useEffect(()=>{
        const qchallenge = query.get("login_challenge")
        console.log("challenge", qchallenge)
        if(qchallenge){
            setChallenge(qchallenge)
        }
        if(qchallenge){
            //handleChallenge(challenge)
        }

    },[])

    async function handleChallenge(challenge : string){
        const redirect_url = await Oauth2Service.auth(challenge)
        window.location.href = redirect_url

    }

  useEffect(() => {
    handleAutoFill();
  }, []);

  async function handleAutoFill() {
    try {
      const result = await LIDService.client.performAction("passkey:auth", {
        autoFill: true,
      });

      if (result.isComplete && result.accessToken) {
        const token = ParseUtil.parseToken(result.accessToken);
        //return props.onComplete(token["username"], token, "passkey");
        handleChallenge(challenge)
      } else {
        setError("invalid credential");
      }
    } catch (e: any) {
      const msg = e.message || e.msg || e;
      console.log(msg);
    }
  }

  function renderNext(view: SignupViewEnum) {
    if (view === SignupViewEnum.OTP) {
      return <OTPVerify email={email} onComplete={handleOTPNext}></OTPVerify>
    } else if (view === SignupViewEnum.CARD) {
      return <CardSelect onComplete={handleCardNext}></CardSelect>
    } else if (view === SignupViewEnum.CVV) {
      return <CvvVerify onComplete={handleCVVNext} index={cardIndex}></CvvVerify>
    } else if (view === SignupViewEnum.PASSKEY) {
      return <AddPasskey onComplete={handlePasskey} email={email}></AddPasskey>
    } else {
      return <EmailInput email={email} onComplete={handleEmailNext}></EmailInput>
    }
  }

  const handlerSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      setError("");

      const result = await LIDService.client.performAction("passkey:auth");

      if (result.isComplete && result.accessToken) {
        const token = ParseUtil.parseToken(result.accessToken);
        //return props.onComplete(token["username"], token, "passkey");
        handleChallenge(challenge)
      } else {
        setError("invalid credential");
      }
    } catch (e: any) {
      setError(e.message || e.msg);
    }
  };


  function handleEmailNext( email:string ) {
    // cancel transaction if email empty
    if(email == "") {
      //return props.onComplete("", "","cancel");
      handleChallenge(challenge)
    }
    setEmail(email);
    setView(SignupViewEnum.OTP);
  }

  function handleOTPNext() {
    handleChallenge(challenge)
    //setView(SignupViewEnum.CARD);
  }
  function handleCardNext(index: number) {
    setCardIndex(index);
    setView(SignupViewEnum.CVV);
  }
  function handleCVVNext() {
    // add passkey
    setView(SignupViewEnum.PASSKEY);
  }

  async function handlePasskey() {

    // Get user confirmation from external system
    try {
      const bankingResult = await WalletMockService.bankingResult(
        null,
        email,
      );

      // Confirm external with loginID
      const lidResult = await LIDService.client.performAction("external", {
        payload: bankingResult.token,
      });
      /// perform passkey creation

      const result = await LIDService.client.performAction("passkey:reg");
      if (result.isComplete && result.accessToken) {
        const token = ParseUtil.parseToken(result.accessToken);
        handleChallenge(challenge)
      //  return props.onComplete(token["username"], token, "passkey");
      } else {
        setError("invalid credential");
      }
      // Else allow passkey registration
    } catch (e) {
      // Redirect back with error
      console.error("Error during external confirmation:", e);
    }
    // Confirm external with loginID
  }

  return (
    renderNext(view)
  );

}

interface OTPNextProps {
  email: string;
  onComplete: (email:string) => void;
}

interface EmailInputProps {
  email: string,
  onComplete: (email:string) => void;
}

function EmailInput(props: EmailInputProps) {
  const [error, setError] = useState("");
  const [email, setEmail] = useState(props.email);

  function onNext() {
    if(email.length > 0 ) {
      props.onComplete(email);
    } else {
      setError("Missing email");
    }
  }

  async function cancelTransaction(){
        return props.onComplete("");
  }
  return (
    <>

      <Stack justify="space-between" style={{ minHeight: "80vh" }} >
        <form
          style={{ width: "100%", justifyItems: "start", flex: 1 }}
        >
          <Flex align="flex-start" justify="flex-start" direction="column" ml="xl" mr="xl" style={{ flex: 1 }}>
            <Title ta="left" order={2} mt="md" mb="sm">
              Enter your email address to continue with {brand}.
            </Title>

            <Text ta="left" size="sm">Enter the email you use with your participating bank or credit union to get access to your {brand} wallet.</Text>
            <Space h="md"></Space>
            <Text fw={500}>Email address</Text>
            <Input
              mb="md"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
              autoComplete="username webauthn"
              w="100%"
              rightSectionPointerEvents="all"
              rightSection={<IconArrowRight color="var(--mantine-primary-color-0)"  onClick={() => onNext()} />}
              error={error}
            />
            {error && <Input.Error>{error}</Input.Error>}

          </Flex>
        </form>

        <Stack justify="center" align="center" style={{ height: "200", width: "100%" }}>
          <Text fw={700} size="sm">Privacy Notice | Service Agreement | Opt out</Text>
          <Button variant="transparent" onClick={cancelTransaction}>Exit {brand} and return to Agent</Button>
        </Stack>
      </Stack>
    </>
  );
}

function OTPVerify(props: OTPNextProps) {
  const [active, setActive] = useState(0);
  return (
    <>
      <Stack justify="space-between" style={{ minHeight: "80vh" }} >
        {/* 
        <StyledStepper active={active} onStepClick={setActive}>
          <Stepper.Step label="Step 1" description="Create an account" />
          <Stepper.Step label="Step 2" description="Verify email" />
          <Stepper.Step label="Step 3" description="Get full access" />
        </StyledStepper>
        */} 
        <form
          style={{ width: "100%", justifyItems: "start", flex: 1 }}
        >
          <Flex align="flex-start" justify="flex-start" direction="column" ml="xl" mr="xl" style={{ flex: 1 }}>
            <Title ta="left" order={2} mt="md" mb="sm">
              Verifying your code.
            </Title>

            <Text ta="left" size="sm">Enter the security code sent to the number ending in <b>7887</b> to confirm it’s you.</Text>
            <Space h="md"></Space>
            <PinInput size="md" length={6} placeholder="" type="number" onComplete={props.onComplete} autoFocus />
            <Text>Didn't receive a code? <span color="blue" style={{ fontWeight: 500 }}>Send a new code.</span></Text>
          </Flex>
        </form>

        <Stack justify="center" align="center" style={{ height: "200", width: "100%" }}>
          <Text fw={700} size="sm">Privacy Notice | Service Agreement | Opt out</Text>
        </Stack>
      </Stack>

    </>
  );
}

interface CardSelectProps {
  onComplete: (index: number) => void;
}

function CardSelect(props: CardSelectProps) {
  const [active, setActive] = useState(1);
  return (
    <>
      <Stack justify="space-between" style={{ minHeight: "80vh", width: "100%" }} >
        <StyledStepper active={active} onStepClick={setActive}>
          <Stepper.Step label="Step 1" description="Create an account" />
          <Stepper.Step label="Step 2" description="Verify email" />
          <Stepper.Step label="Step 3" description="Get full access" />
        </StyledStepper>
        <form
          style={{ width: "100%", justifyItems: "start", flex: 1 }}
        >

          <Flex align="flex-start" justify="flex-start" direction="column" ml="xl" mr="xl" style={{ flex: 1 }}>
            <Title ta="left" order={2} mt="md" mb="sm">
              Select a card to verify.
            </Title>

            <Text ta="left" size="md">No charges will be applied to your card when verifying.</Text>
            <Space h="md"></Space>
            {
              cards.map((card, index) =>

                <Flex direction="row" align="center" w="100%" onClick={() => props.onComplete(index)}>
                  <Image h={64} w={128} src={card.cardUrl} />
                  <Text size="sm" ta="left" ml="xl">
                    <b>{card.name}</b>
                    <br />
                    {card.cardMask}
                  </Text>
                </Flex>
              )
            }
          </Flex>
        </form>

        <Stack justify="center" align="center" style={{ height: "200", width: "100%" }}>
          <Text fw={700} size="sm">Privacy Notice | Service Agreement | Opt out</Text>
        </Stack>
      </Stack>

    </>
  );
}

interface CVVNextProps {
  onComplete: () => void;
  index: number;
}

function CvvVerify(props: CVVNextProps) {
  const [disabled, setDisabled] = useState(true);
  return (
    <>
      <Stack justify="space-between" style={{ minHeight: "80vh", width: "100%" }} >
        <StyledStepper active={2} >
          <Stepper.Step label="1. Verify identity" description="Verify identity" />
          <Stepper.Step label="2. Select card" description="Select card" />
          <Stepper.Step label="3. Enter CVV" description="Enter CVV" />
        </StyledStepper>
        <form
          style={{ width: "100%", justifyItems: "start", flex: 1 }}
        >

          <Flex align="flex-start" justify="flex-start" direction="column" ml="xl" mr="xl" gap="sm" style={{ flex: 1 }}>
            <Title ta="left" order={2} mt="md" mb="sm">
              Verify your card.
            </Title>

            <Space h="sm"></Space>

            <Flex direction="row" align="center" onClick={props.onComplete}>
              <Image h={64} w={128} src={cards[props.index].cardUrl} />
              <Text size="sm" ta="left" ml="xl">
                <b>{cards[props.index].name}</b>
                <br />
                {cards[props.index].cardMask}
              </Text>
            </Flex>
            <Checkbox
              label="Set as default payment for future purchase"
            />
            <Text ta="left" size="sm" >
              Enter your card’s security code (CVV) for first use and unlock your eligible cards for future purchases.
            </Text>
            <Text ta="left" fw={500} >CVV</Text>
            <PinInput length={3} placeholder="" onComplete={() => setDisabled(false)} autoFocus />
          </Flex>
        </form>

        <Stack justify="center" align="center" style={{ height: "200", width: "100%" }}>
          <Divider size="md" />
          <Button disabled={disabled} fullWidth m="md" onClick={(e) => props.onComplete()}>Verify card</Button>
        </Stack>
      </Stack>
    </>
  );

}


interface AddPasskeyNextProps {
  onComplete: () => void;
  email: string;
}
function AddPasskey(props: AddPasskeyNextProps) {

  return (
    <>
      <Stack justify="space-between" style={{ minHeight: "80vh", width: "100%" }} >

        <Flex align="flex-start" justify="flex-start" direction="column" ml="xl" mr="xl" gap="sm" style={{ flex: 1 }}>
          <Title ta="center" order={2} mt="md" mb="sm" w="100%">
            Speed up future checks
          </Title>
          <Text ta="center" pl="xl" pr="xl" size="sm">To authenticate faster next time, use Face ID on your device.</Text>
          <Stack w="100%" justify="center" align="center" p="lg">
            <Image
              src="/assets/faceid.svg"
              w={96}
              h={96} />
            <Text> Learn more</Text>
          </Stack>
          <Group justify="flex-start">
            <IconPlayerSkipForwardFilled />
            <Text ta="left" size="xs" >
              Skip code entry by enrolling your biometrics/pin
            </Text>
          </Group>
          <Group justify="flex-start">
            <IconShieldLock />
            <Text ta="left" size="xs" >
              Protect yourself from fraud by adding your biometrics/pin
            </Text>
          </Group>
          <Button fullWidth mt="md" onClick={(e=>props.onComplete())}>Sure</Button>
          <Button variant="outline" fullWidth >Maybe Later</Button>
        </Flex>

      </Stack>
    </>
  );

}

function StyledStepper(props: StepperProps) {
  return (
    <Stepper
      styles={{
        stepBody: {
          display: 'none',
        },
        step: {
          padding: 0,
        },

        stepIcon: {
          borderWidth: 4,
        },

        separator: {
          marginLeft: -2,
          marginRight: -2,
          height: 10,
        },
      }}
      size="xs"
      {...props}
    />
  );
}